<template>
  <div class="page-template add-page order-add-page">
    <!--    盘点差异单-->
    <!--    <div class="page-title">{{ title }}</div>-->
    <div class="btn-box" style="margin-top: 0">
      <el-button @click="refresh" type="primary" plain>刷新</el-button>
      <el-button @click="beBack" type="primary" plain v-if="$route.query.id">返回</el-button>
      <el-button @click="clickDifference" type="primary" plain v-if="showDifference">生成差异单</el-button>
      <el-button @click="audit" type="primary" plain v-if="showDifferenceAudit">审核</el-button>
      <el-button @click="exportData" type="primary" plain v-if="$route.query.id">导出</el-button>
      <el-button @click="complexFunc" type="primary" plain
      >{{ complexShow ? "收起" : "展开" }}
        <i class="el-icon-arrow-up" v-show="complexShow"></i>
        <i class="el-icon-arrow-down" v-show="!complexShow"></i>
      </el-button>
    </div>
    <list-operation-form v-show="complexShow" ref="listOperationForm"
                         :formOptions="listFormOptions" @valueChange="listFormValueChange"></list-operation-form>
    <div class="search-goods-box">
      <el-input
        placeholder="条码/自编码/助记码"
        class="search-goods-input"
        disabled
      >
        <template slot="prepend">
          <span>综合搜索</span>
        </template>
        <template slot="append">
          <div class="el-icon-search more-btn"></div>
        </template>
      </el-input>
      <el-button type="primary" disabled plain class="select-good"
      >选择商品
      </el-button
      >
      <el-button @click="exportData" type="primary" plain v-if="$route.query.id">导出</el-button>
    </div>
    <list-operation-new
      ref="listOperation"
      :tableOptions="listColumns"
    ></list-operation-new>
    <el-dialog title="商品列表" :visible.sync="listShow" width="1200px" height="800"
               :close-on-click-modal="false">
      <good-list @rowCheck="rowCheck" :isSelect="false" :otherParam="otherParam"></good-list>
    </el-dialog>
    <div
      v-loading.fullscreen.lock="loading"
      element-loading-text="加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(225, 225, 225, 0.9)"
    >
    </div>
  </div>
</template>
<script>
  //商品列表组件
  import goodList from '@/components/business/goodList';
  //添加要货单组件
  import listOperationNew from "@/components/template/listOperationNew";
  //要货单搜索组件
  import listOperationForm from '@/components/template/listOperationForm';
  import api from '@/config/api';

  export default {
    components: {
      listOperationNew,
      goodList,
      listOperationForm
    },
    data() {
      return {
        complexShow: true,
        goodsTxt: "",
        batchId: '',
        loading: false,
        showDifference: true,
        showDifferenceAudit: false,
        title: '',
        listShow: false,
        goodList: [],
        dialogShow: false,
        otherParam: {},
        formModel: {},
        differenceList: [],
        isClearTableData: true,
        // 添加头部字段
        //条件
        listFormOptions: {
          disabled: false,
          statusOption: {
            prop: 'reviewerStatus',
            statusImg: {
              10: '/static/checked.png',
              20: '/static/un-check.png'
            }
          },
          labelWidth: '130px',
          columns:
            [
              {
                label: "仓库",
                type: "warehouseInputDialog",
                prop: "warehouseId",
                url: api.warehouse.warehouse,
                change: this.getBatchOrder,
                param: {relateType: this.$utils.getSysUser().storeId ? 20 : 10},
                data: [],
                span: 12,
                disabled: false,
              },
              {
                label: '盘点单批号',
                type: 'inventoryOrderInputDialog',
                prop: 'batchOrderNo',
                data: [],
                labelKey: 'orderNo',
                uniqueKey: 'orderNo',
                // change: this.orderNoChange,
                span: 12,
                url: api.warehouse.batch + '/batch/page',
                columns: [
                  {label: "单号", prop: "orderNo", align: "center"},
                  {
                    label: "盘点范围",
                    prop: "type",
                    enumData: this.$utils.getCacheStatus('weBatchNumberOrder.type'),
                    align: "center"
                  }
                ]
              }, {
              label: '盘点单批号',
              type: 'input',
              prop: 'batchId',
              hidden: true
            }, {
              label: 'id：',
              type: 'input',
              prop: 'id',
              hidden: true
            }, {
              label: '盘点类型',
              type: 'input',
              prop: 'type',
              hidden: true
            }, {
              label: '盘点类别',
              type: 'input',
              prop: 'retaleIds',
              hidden: true
            }, {
              label: '批号状态',
              type: 'input',
              prop: 'status',
              hidden: true
            },
              //   {
              //   label: '门店',
              //   type: 'select',
              //   prop: 'storeId',
              //   rule: [
              //     {required: true, message: "请选择门店", trigger: "blur"},
              //   ],
              //   data: [],
              //   span: 12,
              //   url: api.system.seStore,
              //   disabled: true,
              // },
              {
                label: '申请人',
                type: 'input',
                prop: 'voucherName',
                disabled: true,
                span: 12,
              }, {
              label: '申请时间',
              type: 'input',
              prop: 'voucherDttm',
              disabled: true,
              span: 12,
            }, {
              label: '审核人',
              type: 'input',
              prop: 'reviewerName',
              disabled: true,
              span: 12,
            }, {
              label: '审核时间',
              type: 'input',
              prop: 'reviewerDttm',
              disabled: true,
              span: 12,
            }, {
              label: '备注',
              type: 'input',
              prop: 'remarks',
              maxLength: 16,
              span: 12,
            }]
        },
        // 添加表格字段
        listColumns: {
          disabled: false,
          indexShow: true,//是否显示索引
          summaryColumns: ['inventoryNum', 'blitemNum', 'quantityVariance', 'amountInventory', 'lossAmount'],
          columns: [
            {label: '序号', type: 'index', width: 100, prop: 'idx'},
            {
              label: '商品条码',
              prop: 'barCode',
              width: '140'
            },
            {
              label: '商品名称',
              prop: 'goodsName',
              width: '100'
            },
            {
              label: '规格',
              prop: 'specs',
              width: '100'
            },
            {
              label: '类别',
              prop: 'goodsCategoryName',
              width: '100'
            },
            {
              label: '供应商',
              prop: 'supplierName',
              width: '100'
            },
            {
              label: '系统库存',
              prop: 'inventoryNum',
              width: '100'
            },
            {
              label: '盘点数量',
              prop: 'blitemNum',
              width: '100'
            },
            {
              label: '差异数量',
              prop: 'quantityVariance',
              width: '100'
            },
            {
              label: '差异原因',
              prop: 'remarks',
              type: 'input',
              width: '200',
              maxLength: 16,
              change: this.remarksChange
            },
            {
              label: '成本价',
              width: '100',
              prop: 'purchasePrice',
            },
            {
              label: '盘点金额',
              width: '100',
              prop: 'amountInventory',
            },
            {
              label: '盈亏金额',
              width: '100',
              prop: 'lossAmount',
            },
            {
              label: '是否修改库存',
              type: 'switch',
              prop: 'updateNum',
              width: '120',
              change: this.updateNumChange,
            },
            {
              label: '处理状态',
              prop: 'status',
              width: '90',
              enumData: this.$utils.getCacheStatus('weBlitemDifferenceGoodsMap.status')
            },
          ],
          param: {batchId: this.$route.query.id},
          url: api.warehouse.differencePage
        },
        checkIndex: '',
        searchForm: {
          warehouseId: '',//仓库id
          batchOrderNo: '',//盘点批号
        }
      }
    },
    created() {
      this.title = document.title;
      if (this.$route.query.id) {
        this.getDetail();
      }else {
        this.$nextTick(() => {
          let warehouseId = this.$utils.getSysUser().warehouseId;
          this.$refs.listOperationForm.formModel.warehouseId = warehouseId;
          this.otherParam.warehouseId = warehouseId;
          this.isSelectWarehouse = false;
          this.listFormOptions.columns.filter(
            item => item.prop === "batchOrderNo"
          )[0].params = {warehouseId: warehouseId};
        })
      }
    },
    methods: {
      //点击 高级搜索显示
      complexFunc() {
        this.complexShow = !this.complexShow;
      },
      listFormValueChange(value, column) {
        if (column.prop == "warehouseId") {
          this.otherParam.warehouseId = value;
          this.isSelectWarehouse = false;
          this.listFormOptions.columns.filter(
            item => item.prop === "batchOrderNo"
          )[0].params = {warehouseId: value};
        }
        if (column.prop == "batchOrderNo") {
          this.orderNoChange(value);
        }
      },
      getDetail() {
        // 是否显示差异按钮
        // this.showDifference = true;
        this.loading = true;
        this.$axios
          .fetchGet(api.warehouse.difference + '/batchId?batchId=' + this.$route.query.id, {})
          .then(data => {
            this.loading = false;
            this.batchId = this.$route.query.id;
            if (data.code === 200 && data.data) {
              this.isClearTableData = false;
              this.formModel = data.data;
              if (this.formModel.reviewerStatus === 10 || this.formModel.reviewerStatus === 50) {
                this.listFormOptions.disabled = true;
                this.listColumns.disabled = true;
              }
              // 是否显示审核按钮
              if (this.formModel.status === 18) {
                this.showDifferenceAudit = true;
                this.listFormOptions.columns[0].disabled = true;
                this.listFormOptions.columns[1].disabled = true;
              }
              this.showDifference = false;
              this.otherParam.goodsCategoryIds = this.formModel.goodsCategoryMVOList;
              this.otherParam.goodsBrandIds = this.formModel.goodsBrandMVOList;
              this.$nextTick(() => {
                //为头部表单赋值
                this.searchForm.warehouseId = data.data.warehouseId
                this.searchForm.batchOrderNo = data.data.batchOrderNo
                this.$refs['listOperationForm'].formModel = data.data;
                //为表格赋值 DifferenceGoodsMapMVOList
                // this.$refs['listOperation'].getTabelData();
                this.$refs.listOperation.clearTableData();
                this.$refs.listOperation.addMoreRow(data.data.differenceGoodsMapMVOList, 0);
              });
            } else if (data.code === 200 && !data.data) {
              this.$message({message: '获取数据出错！', type: 'error'});
              this.$router.push({path: '/warehouse/inventory/goods'});
            } else {
              this.$message({message: data.msg, type: 'error'});
            }
          })
          .catch(err => {
            console.log(err);
            this.$message({message: '请求失败！', type: 'error'});
            this.loading = false;
          });
      },
      numChange(row, index) {
        if (row.retailPrice) {
          row.totalPrice = parseFloat(row.retailPrice * row.num).toFixed(2);
        }
        this.$refs['listOperation'].setColumnData(row, index);
      },
      //选择某行数据
      rowCheck(row) {
        this.listShow = false;
        this.$refs['listOperation'].setColumnData(row, this.checkIndex);
      },
      //提交数据
      submitAuth() {
        let tableList = this.$refs['listOperation'].getTabelData();
        tableList.map(item => {
          item.goodsId = item.id;
        });
        let totalParam = this.$refs['listOperation'].getSumData();
        let headParam = this.$refs.listOperationForm.getFormModel()
        let searchParam = {
          ...{weBlitemGoodsMapMVOList: tableList}, ...totalParam, ...headParam
        };
        this.$axios
          .fetchPost(api.warehouse.blitem, searchParam)
          .then(data => {
            this.loading = false;
            if (data.code == 200) {
              this.dialogShow = false;
              this.$router.push({path: '/warehouse/inventory/goods'});
            } else {
              this.$message({message: data.msg, type: 'error'});
            }
          }).catch(err => {
          this.$message({message: '请求失败！', type: 'error'});
          this.loading = false;
        });
      },
      addRequisition() {
        this.dialogShow = true;
      },
      //获取某行数据填充
      getInfo(rowData, index) {
        this.listShow = true;
        this.checkIndex = index;
      },
      // 选择盘点批号
      orderNoChange(data) {
        this.listFormOptions.columns.filter((item) => item.prop === "batchOrderNo")[0].disabled = true;
        let formModel = this.$refs.listOperationForm.formModel;
        this.showDifference = true;
        this.$refs['listOperation'].clearTableData();
        formModel.batchOrderNo=data.orderNo;
        formModel.id = data.id;
        formModel.type = data.type;
        formModel.retaleInfo = data.retaleInfo;
        formModel.retaleIds = data.retaleIds;
        formModel.storeId = data.storeId;
        formModel.voucherName = data.voucherName;
        formModel.voucherDttm = data.voucherDttm;
        formModel.reviewerName = data.reviewerName;
        formModel.reviewerStatus = data.reviewerStatus;
        formModel.reviewerDttm = data.reviewerDttm;
        formModel.status = data.status;
        formModel.batchId = data.id;
        this.batchId = data.id;
        this.formModel = formModel;
        this.searchForm.batchOrderNo = formModel.batchOrderNo;
        this.searchForm.warehouseId=formModel.warehouseId;
        const loading = this.$loading({
          lock: true,
          text: '数据获取中，请稍候...',
          background: 'rgba(225, 225, 225, 0.9)',
        });
        this.$axios
          .fetchPost(api.warehouse.difference + "/blitem?orderNo=" + formModel.batchOrderNo)
          .then(data => {
            if (data.code === 200) {
              let dataList = data.data['differenceVoList'];
              if (dataList) {
                dataList.map(item => {
                  item.updateNum = true;
                });
                this.$refs.listOperation.clearTableData();
                this.$refs.listOperation.addMoreRow(dataList, 0);
              }
            } else {
              this.$message({message: data.msg, type: 'error'});
            }
          }).catch(err => {
          this.$message({message: '请求失败！', type: 'error'});
        }).finally(() => {
          loading.close();
        });
      },
      refresh() {
        this.$router.go(0);
      },
      // 选择仓库
      getBatchOrder(params) {
        // 根据仓库获取盘点批号
        this.searchForm.warehouseId = params.warehouseId;
        this.$axios.fetchPost(api.warehouse.batch + '/batch/list', {
          reviewerStatus: 20,
          relateType: this.$utils.getSysUser().storeId ? 20 : 10,
          warehouseId: params.warehouseId
        }).then(data => {
          if (data.code === 200) {
            // 清除数据
            if (this.isClearTableData) {
              this.clearData();
            }
            this.listFormOptions.columns.filter(item => item.prop === 'batchOrderNo')[0].data = data.data;
          }
          this.isClearTableData = true;
        })
      },
      // 点击 生成差异单
      clickDifference() {
        let params = this.getParams();
        if (!this.searchForm.warehouseId) {
          this.$message.warning('请先选择仓库')
        } else if (!this.searchForm.batchOrderNo) {
          this.$message.warning('请选择盘点批号')
        } else {
          const loading = this.$loading({
            lock: true,
            text: '正在生成差异单，请稍候...',
            background: 'rgba(225, 225, 225, 0.8)',
          });
          this.$axios
            .fetchPost(api.warehouse.batch + '/create/difference', params)
            .then(data => {
              loading.close()
              if (data.code == 200) {
                this.$message({message: '差异正在生成中，大约十分钟后查看差异结果。', type: 'success'});
                this.$router.push({path: '/warehouse/inventory/batch'});
                // this.$set(this.formModel, 'status', data.data.status);
                // this.$set(this.$refs.listOperationForm.formModel, 'reviewerStatus', 20);
                // this.$refs.listOperation.addMoreRow(data.data['differenceGoodsMapMVOList'], 0);
                // 已经选择的不允许修改 此处数组顺序指的是属性在表单的顺序
                // this.$refs.listOperationForm.formOptions.columns[0].disabled = true;
                // this.$refs.listOperationForm.formOptions.columns[1].disabled = true;
              } else {
                this.$message({message: data.msg, type: 'error'});
              }
            }).catch(err => {
            this.$message({message: '请求失败！', type: 'error'});
            loading.close()
          });
        }

      },
      // 审核
      audit() {
        let params = this.getParams();
        const loading = this.$loading({
          lock: true,
          text: '审核中，请稍候...',
          background: 'rgba(225, 225, 225, 0.8)',
        });
        this.$axios
          .fetchPost(api.warehouse.batch + '/difference/audit', params)
          .then(data => {
            loading.close()
            if (data.code == 200) {
              this.$message({message: '差异正在审核中，大约后查看审核结果。', type: 'success'});
              this.$router.push({path: '/warehouse/inventory/batch'});
              // this.$set(this.formModel, 'status', data.data.status);
              // this.$set(this.$refs.listOperationForm.formModel, 'reviewerStatus', data.data.reviewerStatus);
              // 已经选择的不允许修改 此处数组顺序指的是属性在表单的顺序
              // this.$refs.listOperationForm.formOptions.columns[0].disabled = true;
              // this.$refs.listOperationForm.formOptions.columns[1].disabled = true;
            } else {
              this.$message({message: data.msg, type: 'error'});
            }
          }).catch(err => {
          this.$message({message: '请求失败！', type: 'error'});
          loading.close()
        });
      },
      getParams() {
        // let tableList = this.$refs['listOperation'].getTabelData();
        let totalParam = this.$refs['listOperation'].getSumData();
        let headParam = this.$refs.listOperationForm.getFormModel()
        return {
          ...totalParam, ...headParam
        };
      },
      //返回按钮事件
      beBack() {
        this.$router.go(-1);
      },
      clearData() {
        this.$refs.listOperationForm.formModel.batchOrderNo = "";
        this.$refs['listOperation'].clearTableData();
      },
      remarksChange(param, index) {
        let params = {
          id: param['id'],
          remarks: param['remarks'],
        };
        this.loading = true;
        this.$axios
          .fetchPut(api.warehouse.difference, params)
          .then(data => {
          }).catch(err => {
          this.$message({message: '请求失败！', type: 'error'});
        }).finally(() => {
          this.loading = false;
        });
      },
      updateNumChange(param, index) {
        let params = {
          id: param['id'],
          updateNum: param['updateNum'],
        };
        this.loading = true;
        this.$axios
          .fetchPut(api.warehouse.difference, params)
          .then(data => {
          }).catch(err => {
          this.$message({message: '请求失败！', type: 'error'});
        }).finally(() => {
          this.loading = false;
        });
      },
      exportData() {
        const loading = this.$loading({
          lock: true,
          text: '正在导出...',
          background: 'rgba(225, 225, 225, 0.8)'
        });
        if (this.searchForm.warehouseId === '' || this.searchForm.warehouseId == null ||
          this.searchForm.batchOrderNo === '' || this.searchForm.batchOrderNo == null) {
          loading.close();
          this.$message({message: '仓库和盘点单批号不能为空', type: 'warning'});
          return false;
        }
        if (this.$route.query.id === '' || this.$route.query.id == null) {
          loading.close();
          this.$message({message: '参数异常', type: 'error'});
          return false;
        }
        this.searchForm.id = this.$route.query.id;
        this.$axios.PostBlob(api.warehouse.differenceExport, this.searchForm).then(res => {
          if (res.status === 200) {
            const fileName = '盘点差异单_' + this.searchForm.batchOrderNo + '_' + this.$utils.getDateTime() + ".xlsx";
            let blob = new Blob([res.data])
            let downloadElement = document.createElement('a');
            let href = window.URL.createObjectURL(blob); //创建下载的链接
            downloadElement.href = href;
            downloadElement.download = fileName; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
            this.$notify({
              type: "success",
              title: '导出操作',
              message: '成功!文件名称:' + fileName,
              showClose: false,
            });
            // this.$message.success("导出成功,文件名称:" + fileName);
          } else {
            this.$notify({
              type: "error",
              title: '导出操作',
              message: '失败',
              showClose: false,
            });
            // this.$message.error("导出失败,请稍后再试");
          }
        }).catch(() => {
          this.$message.warning("当前导出数据为空或超出10000条。");
        }).finally(() => {
          loading.close();
        });
      }
    }

  }
</script>
<style scoped>
  >>> .el-dialog__header {
    margin-bottom: 5px;
  }

  .order-add-page .search-goods-box {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-bottom: 10px;
  }

  .order-add-page .search-goods-box .select-good {
    margin-left: 16px;
  }

  .search-goods-input {
    width: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/page/warehouse/inventory/Difference.vue